import { Button } from '@mui/material';
import NavigationClose from '@mui/icons-material/Close';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class MemberItem extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }


    render() {
        const p = this.props;
        return (
            <div style={{ float: 'left' }}>
                {
                    <span>{p.member.firstName + " " + p.member.lastName + ""}
                        <Button
                            onClick={() => p.onTouchTap(p.member)}
                            variant="contained"
                            color="primary"
                            style={{ minWidth: "4%" }}
                            startIcon={<NavigationClose />}
                        >
                        </Button>
                    </span>
                }
            </div>
        );
    }
}

function mapStatetoProps(state, ownProps) {
    return {};
}

export default connect(mapStatetoProps)(MemberItem);